import { render, staticRenderFns } from "./DialogContainer.vue?vue&type=template&id=1b2ceb5b&scoped=true&"
import script from "./DialogContainer.vue?vue&type=script&lang=ts&"
export * from "./DialogContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DialogContainer.vue?vue&type=style&index=0&id=1b2ceb5b&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ceb5b",
  null
  
)

export default component.exports